if (!customElements.get('assisted-wheels-upgrade')) {
  customElements.define(
    'assisted-wheels-upgrade',
    class AssistedWheelsUpgrade extends HTMLElement {
      constructor() {
        super();
        this.checkbox;
        this.visual;
        this.variantId;
        this.currentEwheelsQuantity;
        this.targetEwheelsQuantity;
        this.mainQuantity;
        this.isChecked;
        this.eWheelsOptionLabel;
      }

      connectedCallback() {
        this.init();
      }
      
      init() {
        this.checkbox = this.querySelector('.cart-item__pro-package-checkbox');
        this.visual = this.querySelector('.pro-package-checkbox');
        this.variantId = this.getAttribute('data-e-wheels-variant');
        this.currentEwheelsQuantity = this.getAttribute('data-current-e-wheels-qty');
        this.targetEwheelsQuantity = this.getAttribute('data-target-e-wheels-qty');
        this.mainQuantity = this.getAttribute('data-main-quantity');
        this.isChecked = this.getAttribute('data-is-checked');
        const cartItemContainer = this.closest('.cart-item');
        this.eWheelsOptionLabel = cartItemContainer ? cartItemContainer.querySelector('.e-wheels-upgrade-option') : null;

        if (this.eWheelsOptionLabel) {
          const initiallyActive = (this.isChecked === 'true') || (this.visual && this.visual.classList.contains('checked')) || (Number(this.currentEwheelsQuantity) > 0);
          this.updateLabelVisibility(initiallyActive);
        }

        if (this.checkbox) {
          if (this.isChecked && this.currentEwheelsQuantity !== this.targetEwheelsQuantity) {
            this.updateCart(this.targetEwheelsQuantity)
            .then(newQuantity => {
              if(newQuantity === this.targetEwheelsQuantity) {
                this.currentEwheelsQuantity = newQuantity;
              } else {
                console.error('error updating cart retrying::', this.variantId, this.currentEwheelsQuantity, this.targetEwheelsQuantity, newQuantity);
                this.updateCart(this.targetEwheelsQuantity);
              }
            }).catch(error => {
              console.error('error updating cart retrying::', this.variantId, this.currentEwheelsQuantity, this.targetEwheelsQuantity);
              console.error(error);
              this.updateCart(this.targetEwheelsQuantity);
            });
          }

          // add a click event listener to the checkbox
          this.checkbox.addEventListener('click', () => {
            if (this.variantId) {
              if (this.visual.classList.contains('checked')) {
                // Remove from cart (and any preorder-gate companion parented
                // to this variant)
                this.removeFromCart()
                  .then(() => {
                    if (typeof window.removePreorderCompanionFor === 'function') {
                      return window.removePreorderCompanionFor(this.variantId);
                    }
                  });
                this.visual.classList.remove('checked');
                this.updateLabelVisibility(false);
              } else {
                // Preorder gate "Pause for everyone (no companion)": paused
                // e-wheels can be removed above but never re-added.
                if (typeof window.isPreorderVariantPaused === 'function' &&
                    window.isPreorderVariantPaused(this.variantId)) return;
                // Add to cart
                this.visual.classList.add('checked');
                this.updateLabelVisibility(true);
                this.updateCart(this.mainQuantity)
                .then(() => {
                  this.visual.classList.add('checked');
                  // Gated preorder products bring their companion along no
                  // matter which flow added them (no-op for other products).
                  if (typeof window.maybeAddPreorderCompanion === 'function') {
                    return window.maybeAddPreorderCompanion(this.variantId, 1);
                  }
                })
                .catch(() => {
                  this.visual.classList.remove('checked');
                  this.updateLabelVisibility(false);
                });
              }
            }
          });
        }
      }
      
      async getEWheelsQuantity() {
        const response = await fetch('/cart.js');
        if(response.ok) {
          const data = await response.json();
          return data.items.find(item => item.variant_id == this.variantId)?.quantity || 0;
        } else {
          throw new Error('Failed to get e-wheels quantity');
        }
      }


      async updateCart(quantity) {
        if(!quantity) {
          throw new Error('Quantity is required');
        }
        // Never push the e-wheels line past its own cap (customizer limit
        // and/or Stoq preorder limit) when quantity-matching the wagon.
        const cap = typeof window.getStoqPreorderLimit === 'function'
          ? window.getStoqPreorderLimit(this.variantId)
          : null;
        if (cap) quantity = Math.min(quantity, cap);
        const currentQuantity = this.getEWheelsQuantity(this.variantId);        
        let response;
        if (currentQuantity) {
          response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [this.variantId]: quantity } })
          });
        } else {
          const addPayload = { id: this.variantId, quantity };
          // E-wheels on Stoq preorder: carry its selling plan + the app's line
          // properties (visible shipping text) so it lands as a preorder line.
          const plan = typeof window.getStoqSellingPlanFor === 'function'
            ? window.getStoqSellingPlanFor(this.variantId)
            : null;
          if (plan) {
            addPayload.selling_plan = plan.shopify_selling_plan_id;
            addPayload.properties = window.getStoqPreorderLineProperties(this.variantId);
          }
          response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(addPayload)
          });
        }

        if (response.ok) {
          const data = await response.json();
          const newQuantity = data.items.find(item => item.variant_id == this.variantId)?.quantity || 0;
          this.updateQuantity(newQuantity);
          return newQuantity;
        } else {
          throw new Error('Failed to update cart');
        }
      }
      
      async removeFromCart() {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [this.variantId]: 0 } })
        });
        if (response.ok) {
          const data = await response.json();
          const newQuantity = data.items.find(item => item.variant_id == this.variantId)?.quantity || 0;
          this.updateQuantity(newQuantity);
          return newQuantity;
        } else {
          throw new Error('Failed to remove from cart');
        }
      }

      updateQuantity(quantity) {
        this.currentEwheelsQuantity = quantity;
        if(quantity > 0) {
          this.visual.classList.add('checked');
        } else {
          this.visual.classList.remove('checked');
        }
      }

      updateLabelVisibility(isActive) {
        if (!this.eWheelsOptionLabel) return;
        this.eWheelsOptionLabel.classList.toggle('hidden', !isActive);
      }
    }
  );
}


document.addEventListener('cart:removed-main-variant-for-e-wheels', (ev) => {
  const wheelUpgradeToRemove = ev.detail.wheelUpgradeToRemove;
  fetch(`/cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: { [wheelUpgradeToRemove]: 0 } })
  }).then(() => {
    // The removed e-wheels variant may be a gated preorder product with a
    // companion line parented to it — remove that too (no-op otherwise).
    if (typeof window.removePreorderCompanionFor === 'function') {
      window.removePreorderCompanionFor(wheelUpgradeToRemove);
    }
  });
});
